import { useParams, Link } from 'react-router-dom';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import SEOSchema from '@/components/feature/SEOSchema';
import { getCategoryBySlug, categories } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const category = slug ? getCategoryBySlug(slug) : undefined;

  if (!category) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center pt-16">
        <div className="text-center">
          <h1 className="text-3xl font-black text-foreground-950">分类未找到</h1>
          <Link to="/" className="mt-4 inline-block text-primary-500 hover:text-primary-600 font-semibold">返回首页</Link>
        </div>
      </div>
    );
  }

  const categoryArticles = getArticlesByCategory(slug || '');

  return (
    <>
      <SEOSchema
        type="WebPage"
        data={{
          name: `${category.name} - 911爆料网`,
          url: `https://911baoliao.com/category/${category.slug}`,
          description: category.description,
        }}
      />

      <section className="relative min-h-[420px] flex items-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src={category.image}
            alt={`${category.name} - 911爆料网`}
            title={`${category.name} 吃瓜黑料 - 911爆料网`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-background-950/65 via-background-950/45 to-background-950/70"></div>
        </div>

        <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 pt-24 pb-16">
          <div className="max-w-4xl">
            <div className="mb-5">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: category.name },
                ]}
              />
            </div>
            <div className="flex items-center gap-4 mb-4">
              <div className="w-14 h-14 flex items-center justify-center bg-primary-500/20 rounded-2xl">
                <i className={`${category.icon} text-2xl text-primary-400`}></i>
              </div>
              <h1 className="text-3xl md:text-5xl font-black text-background-50">
                {category.name}
              </h1>
            </div>
            <p className="text-base md:text-lg text-background-50/70 max-w-xl leading-relaxed">
              {category.description}
            </p>
            <span className="inline-block mt-4 px-3 py-1 text-xs font-semibold bg-background-50/10 text-background-50/70 rounded-full">
              共 {categoryArticles.length} 篇爆料
            </span>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6 lg:px-10">
          <div className="flex flex-wrap items-center gap-3 mb-10">
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm font-medium rounded-full transition-all cursor-pointer whitespace-nowrap ${
                  cat.slug === slug
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-50 text-foreground-600 hover:bg-background-200'
                }`}
              >
                {cat.name} ({cat.count})
              </Link>
            ))}
          </div>

          {categoryArticles.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
              {categoryArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <p className="text-foreground-500">该分类暂无爆料内容</p>
            </div>
          )}
        </div>
      </section>

      <section className="relative py-24 md:py-32 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20abstract%20digital%20stream%20of%20leaked%20data%20and%20secrets%2C%20mysterious%20cyber%20noir%20aesthetic%2C%20red%20glowing%20nodes%20and%20connections%2C%20deep%20dark%20background%20with%20dramatic%20contrast%2C%20cinematic%20atmosphere%2C%20clean%20composition%2C%20depth%20and%20mystery&width=1920&height=800&seq=cta-category-911&orientation=landscape"
            alt="下载911爆料网APP获取更多爆料"
            title="911爆料网App下载"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-background-950/75"></div>
        </div>

        <div className="relative z-10 w-full px-4 md:px-6 lg:px-10">
          <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl md:text-6xl font-black text-background-50 leading-[1.05] tracking-tight">
                更多猛料
                <br />
                尽在APP
              </h2>
            </div>
            <div className="flex flex-col gap-6">
              <p className="text-base md:text-lg text-background-50/70 leading-relaxed max-w-md lg:ml-auto">
                下载911爆料网App，第一时间接收推送通知，不错过任何猛料。
              </p>
              <div className="lg:ml-auto">
                <Link
                  to="/about"
                  className="inline-flex items-center gap-3 px-7 py-3.5 text-sm font-semibold bg-background-50 text-foreground-900 rounded-full hover:bg-background-200 transition-all cursor-pointer whitespace-nowrap"
                >
                  立即下载
                  <span className="w-8 h-8 flex items-center justify-center bg-foreground-900 text-background-50 rounded-full">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}